import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import './Toggle.scss';

const Toggle = (props) => {
  const toggle = useRef()
  const checkbox = useRef()

  const handleToggle = () => {
    if (props.onChange) props.onChange()
    toggle.current.classList.toggle('toggled')
    checkbox.current.checked = !checkbox.current.checked
  }
  useEffect(()=>{
    checkbox.current.checked = props.value
  },[props.value])
  return (
    <div className='toggle-container'>
        <input
          ref={checkbox}
          name={props.name}
          className='toggle-checkbox'
          type='checkbox'
          defaultChecked={props.value}
          value={props.value || false}
        />
        <span
          ref={toggle}
          onClick={handleToggle}
          className={props.checked ? 'toggled toggle-switch' : 'toggle-switch'}
        >
          <span className='toggle'></span>
        </span>
        {props.name && <span className='toggle-name'>{props.name}</span>}
    </div>
  )
}

Toggle.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool
}

export default Toggle;
